import 'css-chunksrc/client/pages/projectPage/synthesisPage/reports/styles.scss';export default {
  "reports": "_reports_1im4j_1",
  "filters": "_filters_1im4j_5",
  "main": "_main_1im4j_9",
  "header": "_header_1im4j_15",
  "reportsList": "_reportsList_1im4j_19",
  "noReports": "_noReports_1im4j_23"
};